import React from 'react';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';

import { Container, Button, Row, Col, Form, Spinner } from 'react-bootstrap';
import MaterialTable from 'material-table';
import { dateFormatUtil } from '../Utilities';
import Modal from 'react-bootstrap/Modal';
import EditRounded from '@material-ui/icons/EditRounded';
import Alert from 'react-bootstrap/Alert';
import EditMapping from './EditMapping';
import HistoryMapping from './HistoryMapping';
import OrdersList from './OrdersList';

import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';

import RestServices from '../services/RestServices.js';
import AddEdit from './AddEdit';

class StoretagProfileDetail extends React.Component {
    componentWillUnmount() {}
    async componentDidMount() {}

    render() {
        return (
            <Container className="no_padding">
                <Row style={{ justifyContent: 'center' }}>
                    <h4 style={{ marginLeft: '1rem', marginRight: '1rem' }}>
                        {this.props.selectedRow.StoreTag}
                    </h4>
                </Row>
                <div>
                    <hr />
                </div>
                <Tabs
                    defaultActiveKey="editProfile"
                    id="uncontrolled-tab-example"
                >
                    <Tab eventKey="editProfile" title="Profile">
                        <div>
                            <hr />
                        </div>
                        <AddEdit
                            selectedRow={this.props.selectedRow}
                            {...this.props}
                        />
                    </Tab>

                    <Tab eventKey="editMapping" title="Mapping Details">
                        <div>
                            <hr />
                        </div>
                        <EditMapping
                            selectedRow={this.props.selectedRow}
                            {...this.props}
                        />
                    </Tab>

                    <Tab eventKey="historyMapping" title="Mapping History">
                        <div>
                            <hr />
                        </div>
                        <HistoryMapping
                            selectedRow={this.props.selectedRow}
                            {...this.props}
                        />
                    </Tab>

                    <Tab eventKey="loadOrders" title="Orders">
                        <div>
                            <hr />
                        </div>
                        <OrdersList
                            selectedRow={this.props.selectedRow}
                            {...this.props}
                        />
                    </Tab>
                </Tabs>
            </Container>
        );
    }
}

export default StoretagProfileDetail;
